import { internal, template } from '../../vendor/elix.js';

function ErrorMixin(Base) {
  return class Error extends Base {
    get [internal.template]() {
      return template.concat(
        super[internal.template],
        template.html`
          <style>
              :host([error]) .inputStateContainer,
              :host([error]:hover) .inputStateContainer {
                box-shadow: 0 0 0 var(--tp-selection-box-border-size--selected) var(--tp-color-error-red) !important;
              }
          </style>
        `
      );
    }
  }
}

export default ErrorMixin;
